import type { JanusCallRefs } from './sessionRefs';
import { logJanus } from './utils';

export function hasHealthyInboundSubscriber(r: JanusCallRefs): boolean {
  return r.subscriberFeedsRef.current.some((s) => {
    if (!s.isMediaStarted || !s.pc) return false;
    const ice = s.pc.iceConnectionState;
    if (ice !== 'connected' && ice !== 'completed') return false;
    const audioTrack = s.pc
      .getReceivers()
      .map((rx) => rx.track)
      .find((t) => t?.kind === 'audio');
    return audioTrack?.readyState === 'live' && audioTrack.enabled;
  });
}

export function requestInboundMediaRefresh(
  r: JanusCallRefs,
  sendPublisherMessage: (
    body: Record<string, unknown>,
    jsep?: RTCSessionDescriptionInit,
    transaction?: string
  ) => void
): void {
  if (!r.isJoinedRef.current && r.callStatusRef.current !== 'oncall') return;
  if (!r.handleIdRef.current) return;
  logJanus('IN', 'request listparticipants — refresh inbound');
  sendPublisherMessage({ request: 'listparticipants' }, undefined, 'list-participants-refresh');
}
